/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceRecommendationDetailsRequest {
    getFixupPrototypeFunction() { return ResourceRecommendationDetailsRequest.fixupPrototype; }

    static newInstance(model: Partial<ResourceRecommendationDetailsRequest>): ResourceRecommendationDetailsRequest {
        let obj = Object.assign(new ResourceRecommendationDetailsRequest(), model);
        ResourceRecommendationDetailsRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceRecommendationDetailsRequest>): ResourceRecommendationDetailsRequest {
        if (!model) return null;
        return ResourceRecommendationDetailsRequest.newInstance(<ResourceRecommendationDetailsRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceRecommendationDetailsRequest) {
        if (!obj) return;

        models.ResourceRecommendationDetailsRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceRecommendationDetailsRequest): boolean {
        Object.setPrototypeOf(obj, ResourceRecommendationDetailsRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * List of resource IDs to get the resource recommendations.
     */
    resource_ids: Array<string>;

    /**
     * Service account ID to filter the resource recommendations.
     */
    service_account_id: string;

    /**
     * Policy ID to filter the resource recommendations.
     */
    policy_id: string;

}
